/** Angular `liberty_loadTaggingUser` — Liberty organization, Active users only. */
export const MENTION_USER_ENDPOINT = "/api/user";
export const MENTION_DEFAULT_USER_PARAMS = {
  organization_type: "LIBERTY",
  perPage: 100,
  account_status: "Active",
} as const;

export const MENTION_SEARCH_DEBOUNCE_MS = 200;
/** Delay on blur so a mousedown on an option still fires before the list closes. */
export const MENTION_BLUR_CLOSE_DELAY_MS = 150;

export const MENTION_DROPDOWN_WIDTH = 260;
export const MENTION_DROPDOWN_HEIGHT = 220;
export const MENTION_DROPDOWN_VIEWPORT_INSET = 16;
export const MENTION_DROPDOWN_CARET_GAP = 4;
/** Extra gap when the list flips above the caret. */
export const MENTION_DROPDOWN_FLIP_GAP = 8;

export const CARET_MIRROR_DIV_ID = "input-textarea-caret-position-mirror-div";
export const CARET_MIRROR_FALLBACK_LINE_HEIGHT = 20;

/** Copied onto the mirror div so it wraps text exactly like the textarea. */
export const CARET_MIRROR_COPIED_STYLE_PROPERTIES = [
  "direction",
  "boxSizing",
  "width",
  "height",
  "overflowX",
  "overflowY",
  "borderTopWidth",
  "borderRightWidth",
  "borderBottomWidth",
  "borderLeftWidth",
  "borderStyle",
  "paddingTop",
  "paddingRight",
  "paddingBottom",
  "paddingLeft",
  "fontStyle",
  "fontVariant",
  "fontWeight",
  "fontStretch",
  "fontSize",
  "fontSizeAdjust",
  "lineHeight",
  "fontFamily",
  "textAlign",
  "textTransform",
  "textIndent",
  "textDecoration",
  "letterSpacing",
  "wordSpacing",
  "tabSize",
] as const;
